import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueNativeSock from 'vue-native-websocket';
import AsyncComputed from 'vue-async-computed';

import App from './App.vue';
import store from './store';
import router from './router.js';
import auth from './services/auth';
import moment from 'moment';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);
Vue.use(VueAxios, axios);
Vue.use(AsyncComputed);

import VueCountdown from '@xkeshi/vue-countdown';
Vue.component('countdown', VueCountdown);

import VueStripeCheckout from 'vue-stripe-checkout';

const options = {
    key: 'pk_live_VUwnSag8X8JV2pt6VtwlCrIn',
    // key: 'pk_test_hEWeSlYmtl3P30cPDktJUubn',
    image: 'https://www.escapeitkit.com/img/logo_100x100.png',
    locale: 'auto',
    currency: 'usd',
    billingAddress: true,
    panelLabel: 'Checkout {{amount}}'
};

Vue.use(VueStripeCheckout, options);

let SOCKET_ADDRESS = 'wss://api.escapeitkit.com:443';
if (location.hostname === 'localhost') {
    SOCKET_ADDRESS = 'ws://localhost:8001';
}

Vue.use(VueNativeSock, SOCKET_ADDRESS, {
    format: 'json',
    store: store,
    reconnection: true,
    reconnectionAttempts: 20, // (Number) number of reconnection attempts before giving up
    reconnectionDelay: 5000, // (Number) how long to initially wait before attempting a new attempt
});

new Vue({
    el: '#app',
    router,
    store, // this gives us access to this.$store in our components
    components: { App },
    template: '<App/>'
});

Vue.filter('date', function(value, format) {
    if (value) {
        return moment(String(value)).format(format)
    }
});



// WEBPACK FOOTER //
// ./src/main.js